import { render, staticRenderFns } from "./modal-event-tip.vue?vue&type=template&id=8800cbbe"
import script from "./modal-event-tip.vue?vue&type=script&lang=js"
export * from "./modal-event-tip.vue?vue&type=script&lang=js"
import style0 from "./modal-event-tip.vue?vue&type=style&index=0&id=8800cbbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports